import StudentGameAPI from '@/apis/business/student/student-game-api.js'

export default {
  namespaced: true,
  state: {
    studentGalacticGame: {},
    submitGalacticGame: {}, // param lưu kết quả nộp bài
    selectedQuestion: 1, // Index câu hỏi đang được chọn
    avatarSelected: '', // Avatar chiến binh user đã chọn
    numberQuestion: 0,
    scoreResult: null,
    scoreLastTime: 0,
    playMusic: true,
    studentGameId: ''
  },

  mutations: {
    /**
     * @param {*} state
     * @param {*} data
     * @description set giá trị mới cho state avatarSelected
     * @author THNhat
     */
    mapAvatarSelected (state, data) {
      state.avatarSelected = data
    },
    /**
     * @description set index câu hiện tại
     * @author VDDung1
     * @param {*} state
     * @param {*} sortOrder
     */
    setSelectedQuestion (state, sortOrder) {
      state.selectedQuestion = sortOrder
    },

    /**
     * @description set tổng số câu hỏi
     * @author VDDung1
     * @param {*} state
     * @param {*} totalQuestion
     */
    setNumberQuestion (state, totalQuestion) {
      state.numberQuestion = totalQuestion
    },

    /**
     * @description set giá trị học sinh chơi game
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setSubmitGalacticGame (state, data) {
      state.submitGalacticGame = data
    },

    /**
     * @description set giá trị điểm tổng để xếp hạng
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setScoreResult (state, data) {
      state.scoreResult = data
    },

    /**
     * @description set giá trị điểm lần trước đó
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setScoreLastTime (state, data) {
      state.scoreLastTime = data
    },

    /**
     * @description set nhạc nền cho game
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setPlayMusic (state, data) {
      state.playMusic = data
    },

    /**
     * @description set studentGameId
     * @author THNhat
     * @param {*} state
     * @param {*} data
     */
    setStudentGameId (state, data) {
      state.studentGameId = data
    }
  },
  getters: {},

  actions: {
    /**
     * @author VDDung1
     * @description lấy thông tin trò chơi chiến binh thiên hà
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getStudentGalacticGame (context, studentGameID) {
      return new Promise((resolve, reject) => {
        StudentGameAPI.getAsync(
          `galactic-warrior?studentGameID=${studentGameID}`
        )
          .then((res) => {
            if (res.Data) {
              context.commit('setSubmitGalacticGame', res.Data)
              // set giá trị câu học sinh đang làm
              if (res.Data.SubmitGame) {
                const questionDone = res.Data.SubmitGame.Questions.filter(
                  (x) => x.Done === true
                )
                const imageCharacter = res.Data.ImageCharacter
                context.commit('setSelectedQuestion', questionDone.length + 1)
                context.commit('mapAvatarSelected', imageCharacter)
              } else {
                context.commit('setSelectedQuestion', 1)
                context.commit('mapAvatarSelected', '')
              }

              context.commit('setNumberQuestion', res.Data.Questions.length)
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author VDDung1
     * @description lấy thông tin điểm và xếp hạng câu hỏi học sinh vừa submit
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getSubmitQuestionGalacticGame (context, params) {
      return new Promise((resolve, reject) => {
        StudentGameAPI.postAsync('submit-galactic-game', params)
          .then((res) => {
            if (res.Data) {
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author VDDung1
     * @description cập nhật avatar user
     * @param {*} studentGameID
     * @param {*} avatar : string
     * @returns
     */
    async updateAvatarGalacticGame (context, params) {
      return new Promise((resolve, reject) => {
        StudentGameAPI.postAsync(
          `choose-character?studentGameID=${params.StudentGameID}&characterImage=${params.CharacterImage}`
        )
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
